module.exports = __webpack_public_path__ + "img/V-45-ER-1000-B.3f46d365.png";